import React from 'react';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { TextVariant } from '@naf/text';
import xor from 'lodash/xor';
import { ExpandLess } from '@styled-icons/material/ExpandLess';
import { ExpandMore } from '@styled-icons/material/ExpandMore';
import { LocalDepartments } from '../../../../../../types/nafLocations';
import * as S from './NafCenters.styles';

interface CountyFilterProps {
  nafLocationsByCounty: LocalDepartments[];
  selectedCounties: string[];
  onChange: (counties: string[]) => void;
  isOpen: boolean;
  onToggle: () => void;
  topSlot?: React.ReactNode;
}

const CountyFilter = ({
  nafLocationsByCounty,
  selectedCounties,
  onChange,
  isOpen,
  onToggle,
  topSlot,
}: CountyFilterProps) => (
  <S.Filter>
    {topSlot}
    <S.FilterHeader onClick={onToggle} variant={TextVariant.BodyTextHeader}>
      Filtrer på fylke
      <S.AccordionIcon>{isOpen ? <ExpandLess size={24} /> : <ExpandMore size={24} />}</S.AccordionIcon>
    </S.FilterHeader>
    {isOpen && (
      <>
        <Checkbox name="alle" checked={selectedCounties.length === 0} onChange={() => onChange([])} label="Alle" />
        {nafLocationsByCounty.map(({ county }) => (
          <Checkbox
            key={county.name}
            name={county.slug}
            checked={selectedCounties.includes(county.slug)}
            disabled={county.total === 0}
            onChange={() => onChange(xor(selectedCounties, [county.slug]))}
            label={`${county.name} (${county.total})`}
          />
        ))}
      </>
    )}
  </S.Filter>
);

export default CountyFilter;
